import React, { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { storage } from '../firebase/firebaseConfig';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';

const UploadVideoBackgraoundHero = ({ setVideoUrl }) => {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const storageRef = ref(storage, `videosfondocalocho/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    setUploading(true);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
      },
      (error) => {
        console.error(error);
        setUploading(false);
      },
      async () => {
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          // Verifica que setVideoUrl se esté llamando correctamente
          console.log('Estoy resolviendo aquí en setVideo ', setVideoUrl);
          console.log('Estoy resolviendo aquí en downloadURL ', downloadURL);
          if (typeof setVideoUrl === 'function') {
            setVideoUrl(downloadURL);
          } else {
            console.error("setVideoUrl no es una función");
          }
          setUploading(false);
        } catch (error) {
          console.error('Error al obtener el URL del video:', error);
          setUploading(false);
        }
      }
    );
  };

  return (
    <Box>
      <input
        accept="video/*"
        style={{ display: 'none' }}
        id="upload-video"
        type="file"
        onChange={handleUpload}
      />
      <label htmlFor="upload-video">
        <Button variant="outlined" component="span">
          Subir Video
        </Button>
      </label>
      {uploading && <CircularProgress variant="determinate" value={progress} />}
    </Box>
  );
};

export default UploadVideoBackgraoundHero;